<template>
  <div class="light-grey">
    <div class="home-box">
      <div class="container">
        <div class="suite--list">
          <div class="page">
            <div class="title-room">
              <h2 class="titlesection">{{$t('home.titles.roomHighlighted').toUpperCase()}}</h2>
              <h3 class="titlesection">{{$t('home.titles.roomHighlightedDescription')}}</h3>
            </div>
            <div class="room-highlight--list">
              <ul>
                <li v-if="loading" v-for="(item, index) in [1,2,3,4]" :key="item" :index="index">
                  <a href="#" class="room-card-empty">
                    <div class="ph-item">
                      <div class="ph-picture"></div>
                      <div class="ph-col-12">
                        <div class="ph-row">
                          <div class="ph-col-10 empty"></div>
                          <div class="ph-col-6 big"></div>
                          <div class="ph-col-6 big empty"></div>
                          <div class="ph-col-6"></div>
                          <div class="ph-col-6 empty"></div>
                        </div>
                        <div class="ph-row"></div>
                        <div class="ph-row"></div>
                        <div class="ph-row">
                          <div class="ph-col-8"></div>
                          <div class="ph-col-4 empty"></div>
                          <div class="ph-col-12"></div>
                          <div class="ph-col-10"></div>
                          <div class="ph-col-12"></div>
                        </div>
                        <div class="ph-footer">
                          <div class="ph-btn"></div>
                        </div>
                      </div>
                    </div>
                  </a>
                </li>
                <li v-for="(room, index) in rooms" :item="room" :index="index" :key="room.name" v-if="!loading">
                  <router-link tag="a" :to="{name: 'room', params: {id: room.id, slug: slug(room.text.short_name)}}" class="room-card">
                    <span class="title-label">{{room.area}} m<sup>2</sup></span>
                    <span class="image--wrapper">
                      <img v-lazy="`${room.main_picture.absolute_path}?h=320&crop-to-fit`"/>
                    </span>
                    <div class="textesuite">
                      <h4>{{room.text.short_name.toUpperCase()}}</h4>
                      <h5 v-if="room.room_group">{{room.room_group.text.name}}</h5>
                      <h5 v-else></h5>
                      <p v-html="room.text.short_desc"></p>
                      <div class="white-shadow"></div>
                    </div>
                    <div class="room-footer">
                      <div class="card-button">
                        <router-link tag="div" :to="{name: 'room', params: {id: room.id, slug: slug(room.text.short_name)}}" class="btn btn-right">
                          {{$t('roomHighlighted.discoverButton')}}
                        </router-link>
                      </div>
                    </div>
                  </router-link>
                </li>
                <!--<li>
                  <a href="#" class="room-card">
                  <span class="image&#45;&#45;wrapper">
                  <img v-lazy="`/static/img/suites/allsuites.jpg`"/>
                </span>
                    <div class="textesuite">
                      <div class="cityhome">{{$t('roomHighlighted.pub.country')}}</div>
                      <h4>{{$t('roomHighlighted.pub.title')}}</h4>
                      <h5>{{$t('roomHighlighted.pub.description')}}</h5>
                      <p>{{$t('roomHighlighted.pub.content')}}</p>
                      <div class="white-shadow"></div>
                    </div>
                    <div class="room-footer">
                      <router-link tag="div" :to="{name: 'roomDetail'}" class="btn btn-right">
                        {{$t('roomHighlighted.pub.button')}}
                      </router-link>
                    </div>
                  </a>
                </li>-->
              </ul>
            </div>
            <div class="room-discover">
              <div class="colored-btn grey-purple-btn">
                <router-link tag="div" :to="{name: 'places'}" class="btn btn-right">
                <span>
                  {{$t('roomHighlighted.pub.button')}}
                </span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import ImageComponent from '../../components/image.component';
  import {TextHelper} from "../../helpers/text.helper";

  export default {
    name: 'room-highlighted',
    components: {
      ImageComponent,
    },
    computed: mapState({
      rooms: state => state.roomHighlighted.rooms,
      loading: state => state.roomHighlighted.loading,
    }),
    methods: {
      slug (v) {
        return TextHelper.slugify(v);
      }
    },
    async created() {
      await this.$store.dispatch('roomHighlighted/fetch', {lang: this.$store.state.lang.currentLang});
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/home/room-highlighted.vue